import http from "@/common/http.service";
const ROOT_URL = "tag/list";
const TAG_SAVE = "tag/save";
const DELETE_URL = "tag/delete";
const GET_TAG = "campaign/get-tags";
export default {
  fetchItems(params, cb, key = "") {
    http.post(ROOT_URL, params, "", "", key).then(function (response) {
      var data = {};
      if (response.data.totalRows) {
        data = {
          items: response.data.data,
          total: response.data.totalRows,
        };
      } else {
        data = { items: response.data };
      }
      cb(data);
    });
  },

  deleteTag(id) {
    return http.post(DELETE_URL, { id: id });
  },
  getTag(params) {
    return http.post(GET_TAG, params);
  },
};

export const saveTag = (params) => {
  return http.post(TAG_SAVE, params);
};
